<template>
  <div class="screen-root">
    <div class="screen" id="app">
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    // 初始化自适应  ----在刚显示的时候就开始适配一次
    this.handleScreenAuto()
    // 绑定自适应函数   ---防止浏览器栏变化后不再适配
    window.onresize = () => this.handleScreenAuto()
  },
  destroyed() {
    window.onresize = null
  },
  methods: {
    getScale(width = 1920, height = 1080) {
      const ww = window.innerWidth / width
      const wh = window.innerHeight / height
      return ww < wh ? ww : wh
    },
    // 数据大屏自适应函数
    handleScreenAuto() {
      // 根据屏幕的变化适配的比例
      const scale = this.getScale()
      // 缩放比例
      document.querySelector(
        '#app'
      ).style.transform = `scale(${scale}) translate(-50%, -50%)`
    }
  }
}
</script>
<style lang="scss" scoped>
.screen-root {
  width: 100%;
  height: 100%;
  position: relative;
  background-image: url(@/assets/home/bg.png);
  background-size: cover;
  overflow: hidden;
  .screen {
    display: inline-block;
    width: 1920px; //设计稿的宽度
    height: 1080px; //设计稿的高度
    transform-origin: 0 0;
    position: absolute;
    left: 50%;
    top: 50%;
  }
}
</style>
